<template>
    <div style="height:100%;">
        <p style="display: flex;
         font-size: 30px;
         flex-direction: row;
         height: 45px;
         color: rgb(221,114,2);
         border-bottom: solid 0.06rem rgb(193,193,193);">
         WEAT enrichment analysis: Blood Expression
        </p> 
        <el-card style="width:100%;
            height:auto;
            margin-left: auto;
            margin-right: auto;
            margin-top: 15px;">
                <div style="width:95%;display: inline-block;vertical-align: middle;margin:auto;font-size: 18px;text-align: left;line-height: 30px;">
                In this section, we show the results of <strong style="font-size:22px;">GO enrichment</strong> analysis and <strong style="font-size:22px;">KEGG pathway enrichment</strong> analysis 
                using the weighted enrichment analysis tool <a href="http://www.cuilab.cn/weat/">WEAT</a>. We used the gene scores generated from GTEx_smts blood expression, which was derived from the WEAT method study to weight each gene.
                </div>        
            </el-card>    
        <el-tabs style="height:100%;margin-top: 50px;" type="border-card" v-model="activePane" @tab-click="handleClick">
        <!-- Data -->
            <el-tab-pane label="GO enrichment" name="go">
                Select domains: 
                <el-select @change="selectChanged" v-model="activeType" placeholder="Choose type" >
                    <el-option
                        v-for="item in typeOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <br/><br/>
                <BubblechartVue :plotData="plotData" :name="yaxis" v-if="activePane=='go'"></BubblechartVue>
                <el-table ref="GOtable" class="table" :data="tableData"  style="width: 98%;margin: auto;" height=650px @sort-change='sortChange' :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}"   >
                    <el-table-column v-for='(item,key)  in tableFields' :key='key' :formatter="item.formatter" :prop='item.key' :label='item.label' :sortable="item.sortable" :width="item.width" :min-width="item.minWidth"/>          
                </el-table>
                <el-pagination
                    @size-change="(val) => handleSizeChange(val)"
                    @current-change="(val) => handleCurrentChange(val)"
                    :current-page="currentPage"
                    :page-sizes="[10,20,30]"
                    :page-size="10"
                    layout="->,total, sizes, prev, pager, next, jumper"
                    :total= this.totalCount
                    style="margin-left:auto">
                </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="KEGG pathway enrichment" name="kegg">
                <br/><br/>
                <BubblechartVue :plotData="KEGGData" :name="yaxis" v-if="activePane=='kegg'"></BubblechartVue>
                <el-table ref="KEGGtable" class="table" :data="tableData"  style="width: 98%;margin: auto;" height=650px @sort-change='sortChange' :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}"   >
                    <el-table-column v-for='(item,key)  in tableFields' :key='key' :formatter="item.formatter" :prop='item.key' :label='item.label' :sortable="item.sortable" :width="item.width" :min-width="item.minWidth"/>          
                </el-table>
                <el-pagination
                    @size-change="(val) => handleSizeChange(val)"
                    @current-change="(val) => handleCurrentChange(val)"
                    :current-page="currentPage"
                    :page-sizes="[10,20,30]"
                    :page-size="10"
                    layout="->,total, sizes, prev, pager, next, jumper"
                    :total= this.totalCount
                    style="margin-left:auto">
                </el-pagination>
            </el-tab-pane>
           
        </el-tabs>
    </div>
</template>

<script>
import BubblechartVue from '../../../chart/BubbleWeatchart.vue';
import{Loading}from'element-ui';
export default{
    data(){    
        return{
            tableData:[],
            yaxis:'GO term',
            // 默认显示第几页
            currentPage:1,
            // 总条数，根据接口获取数据长度(注意：这里不能为空)
            totalCount:1,
            // 默认每页显示的条数（可修改）
            pageSize:10,
            desc:null,
            sortby:null,
            activePane:"go",
            activeType:'Biological Process',
            tableFields: [
                { key: "description", label: "Description", sortable: true,width:'150px'},
                { key: "count_ratio", label: "Count ratio", sortable: true,width:120},
                { key: "score_ratio", label: "Score ratio", sortable: true,width:120},
                { key: "or", label: "OR", sortable: true,width:100},
                { key: "wor", label: "WOR", sortable: true,width:110},
                { key: "wpvalue", label: "WP-value", sortable: true ,width:110},
                { key: "bonferroni", label: "Bonferroni",sortable: true ,width:120,formatter:this.rounding},
                { key: "fdr", label: "FDR",sortable: true ,width:100,formatter:this.rounding},
                { key: "gene_name", label: "Gene name", sortable: true,minWidth:350},
                // { key: "type", label: "Category", sortable: true,width:120},
                // { key: "background", label: "Score generation", sortable: true,width:120}
            ],
            typeOption:[{
                value: 'Biological Process',
                label: 'Biological Process'
                },{
                value: 'Cellular Component',
                label: 'Cellular Component'
                },{
                value: 'Molecular Function',
                label: 'Molecular Function'
                }],
            plotData: null,
            BPData:[[1,'superior temporal gyrus development','2/2','Infinity','2.00/2.00','Infinity',0,0,0,2,50],
                [0.321158382819491,'chemical synaptic transmission','79/246','6.18','78.96/245.86','6.17',4.41E-30,5.4E-26,2.7E-26,79,29.3555614105322],
                [0.171920674041382,'signal transduction','180/1047','2.82','179.97/1046.82','2.82',2.51E-27,3.07E-23,1.02E-23,180,26.600326278519],
                [0.27625738352382,'cytokine-mediated signaling pathway','79/286','4.97','79.04/286.11','4.97',1.09E-24,1.34E-20,3.35E-21,79,23.9625735020594],
                [0.281101132370168,'response to drug','72/256','5.07','71.99/256.10','5.07',4.85E-23,5.95E-19,1.19E-19,72,22.3142582613977],
                [0.227992074316152,'inflammatory response','88/388','3.83','88.60/388.61','3.85',2.43E-21,2.99E-17,4.98E-18,88,20.6143937264017],
                [0.221943704632096,'positive regulation of gene expression','85/383','3.71','85.00/382.98','3.71',2.94E-20,0.000000000000000361,5.16E-17,85,19.5316526695878],
                [0.336004042153891,'response to lipopolysaccharide','46/138','6.39','46.55/138.54','6.47',3.52E-19,0.00000000000000432,0.00000000000000054,46,18.4534573365219],
                [0.307205016636806,'aging','48/156','5.68','48.01/156.28','5.67',0.000000000000000022,0.00000000000027,0.00000000000003,48,16.6575773191778],
                [0.307416421160497,'response to hypoxia','48/156','5.68','48.00/156.14','5.67',0.000000000000000027,0.000000000000331,0.0000000000000331,48,16.568636235841],

                ],
            MFData:[[0.198851701442375,'enzyme binding','71/357','3.24','71.00/357.05','3.24',0.0000000000000288,0.000000000125,0.000000000125,71,9.90308998699194],
                [0.195762025740529,'signaling receptor binding','70/358','3.17','70.12/358.19','3.17',0.0000000000000915,0.000000000397,0.000000000198,70,9.40120949323689],
                [0.240678328786177,'cytokine activity','45/187','4.08','44.99/186.93','4.08',0.000000000000918,0.00000000398,0.00000000133,45,8.40011692792631],
                [0.12227811442728,'identical protein binding','178/1457','1.86','178.18/1457.17','1.86',0.00000000000598,0.0000000259,0.00000000648,178,7.58670023591875],
                [0.245442828208433,'growth factor activity','40/163','4.18','39.99/162.93','4.18',0.00000000000877,0.000000038,0.0000000076,40,7.42021640338319],
                [0.0822070638562159,'protein binding','1013/12327','1.51','1013.90/12333.49','1.51',0.0000000000627,0.000000272,0.0000000453,1013,6.5654310959658],
                [0.204899233884741,'transcription regulatory region sequence-specific DNA binding','42/205','3.31','41.99/204.93','3.31',0.00000000117,0.00000506,0.000000723,42,5.2958494831602],
                [0.466644429619747,'neuropeptide hormone activity','14/30','11.1','13.99/29.98','11.09',0.00000000646,0.000028,0.0000035,14,4.55284196865778],
                [0.749791492910759,'serotonin binding','9/12','37.94','8.99/11.99','37.93',0.0000000115,0.0000498,0.00000465,9,4.30277065724028],
                [1,'extracellularly ATP-gated cation channel activity','7/7','Infinity','7.00/7.00','Infinity',0.0000000118,0.0000511,0.00000465,7,4.29157909986529],

                ],
            CCData:[[0.145792402097809,'extracellular region','273/1870','2.52','273.82/1878.15','2.51',3.47E-32,6.1E-29,6.1E-29,273,31.4596705252091],
                [0.248706577974871,'dendrite','101/406','4.55','100.95/405.90','4.54',2.7E-29,4.76E-26,2.38E-26,101,28.568636235841],
                [0.145053361662637,'extracellular space','237/1630','2.45','237.58/1637.88','2.45',4.79E-27,8.44E-24,2.81E-24,237,26.3196644865854],
                [0.147200079219686,'integral component of plasma membrane','208/1414','2.45','208.11/1413.79','2.45',1.54E-24,2.71E-21,6.76E-22,208,23.8124792791635],
                [0.10452326757982,'plasma membrane','492/4714','1.8','492.73/4714.07','1.8',4.92E-22,8.66E-19,1.73E-19,492,21.3080348972326],
                [0.239825490807105,'neuron projection','77/321','4.27','76.96/320.90','4.26',1.65E-21,2.9E-18,4.84E-19,77,20.7825160557861],
                [0.236346002303449,'neuronal cell body','78/330','4.19','77.98/329.94','4.18',2.25E-21,3.96E-18,5.65E-19,78,20.6478174818886],
                [0.223581647755303,'glutamatergic synapse','68/304','3.87','67.98/304.05','3.87',6.65E-17,0.000000000000117,0.0000000000000146,68,16.1771783546969],
                [0.215160948469996,'axon','65/302','3.67','64.97/301.96','3.67',0.000000000000000738,0.0000000000013,0.000000000000144,65,15.131943638177],
                [0.283686936777123,'postsynaptic membrane','40/141','5.25','39.98/140.93','5.24',0.0000000000000225,0.0000000000396,0.00000000000396,40,13.6478174818886],

            ],
            KEGGData: [[0.328724698595288,'Neuroactive ligand-receptor interaction','119/362','4.78','118.88/361.64','4.78',4.71E-33,1.65E-30,1.65E-30,119,32.3269790928711],
                [0.304153807657019,'Calcium signaling pathway','73/240','4.06','72.93/239.78','4.06',2.94E-18,0.00000000000000103,0.000000000000000515,73,17.5316526695878],
                [0.412343077868493,'Glutamatergic synapse','47/114','6.38','46.97/113.91','6.39',5.11E-18,0.00000000000000179,0.000000000000000596,47,17.2915790998653],
                [0.297724840645792,'Lipid and atherosclerosis','64/215','3.9','63.99/214.93','3.9',0.00000000000000111,0.000000000000388,0.0000000000000969,64,14.9546770212133],
                [0.289543993116877,'cAMP signaling pathway','64/221','3.74','63.94/220.83','3.74',0.00000000000000544,0.0000000000019,0.000000000000381,64,14.2644011003018],
                [0.373999303863557,'Serotonergic synapse','43/115','5.4','42.98/114.92','5.41',0.00000000000000921,0.00000000000322,0.000000000000537,43,14.0357403698032],
                [0.385066960190791,'HIF-1 signaling pathway','42/109','5.67','41.98/109.02','5.66',0.0000000000000271,0.00000000000947,0.00000000000135,42,13.5670307091256],
                [0.207175969547356,'Pathways in cancer','110/531','2.46','109.94/530.66','2.46',0.000000000000212,0.0000000000741,0.00000000000926,110,12.6736641390712],
                [0.386796445196784,'IL-17 signaling pathway','36/94','5.58','36.56/94.52','5.67',0.000000000000281,0.0000000000983,0.0000000000109,36,12.5512936800949],
                [0.333333333333333,'Dopaminergic synapse','44/132','4.52','43.97/131.91','4.52',0.000000000000515,0.00000000018,0.000000000018,44,12.2881927709588],
            ]
        }
    },
    components:{
        BubblechartVue
    },
    mounted () {
        this.plotData=this.BPData
        this.getData()
    },
    methods:{
        getData(){
            console.log(this.activePane=="go"?this.activeType:"KEGG")
            var loadingInstance = Loading.service({
                target:document.querySelector('.table')
            });
            this.axios.get(this.GLOBAL.rootAddress+'analysis/enrichment/weat_gtxblood',{
            params: { 
                'pageNum': this.currentPage,
                'pageSize': this.pageSize,
                'sortBy':this.sortby,
                'desc':this.desc,
                'type':this.activePane=="go"?this.activeType:"KEGG"
            }
            })
            .then(response=> {
                loadingInstance.close();
                this.totalCount=response.data.data.total;               
                this.tableData=response.data.data.records;   
            })
            .catch(error=> {
                loadingInstance.close();
                console.log(error);
            });
        },
        handleClick(val){
            this.getData() 
            this.currentPage=1
            if(this.activePane=='go')this.yaxis="GO term"
            else this.yaxis="KEGG pathway"
        },
        // 改变每页显示的条数 
        handleSizeChange(val) { 
            this.pageSize=val
            this.currentPage=1
            this.getData()            
            },
        // 改变当前页数
        handleCurrentChange(val) {
            this.currentPage=val
            this.getData()
        },
        sortChange(column, prop, order){
            this.currentPage=1
            if(column.order){
                this.sortby=column.prop
                if(column.order=='ascending'){
                    this.desc=1
                }else this.desc=0
            }else{
                this.sortby=null
                this.desc=null
            }
            this.getData()
        },
        rounding(row,column) {
            return row[column.property].toExponential(3)
        },
        selectChanged(){
            if(this.activeType=='Biological Process'){
                this.plotData=this.BPData
            }else if(this.activeType=='Cellular Component'){
                this.plotData=this.CCData
            }else {
                this.plotData=this.MFData
            }
            if (this.$refs.table){
                this.$refs.table.clearSort()
            }
            this.currentPage=1
            this.currentPageIndex=0
            this.desc=null
            this.sortby=null
            this.pageSize=10
            this.getData()
        },

    },
}


</script>

<style>

</style>